<kendo-dialog
  [title]="dialogTitle()"
  (close)="close()"
  [minWidth]="550"
  [width]="650"
>
  <div class="dialog-content">
    <!-- Source Selection -->
    <div class="form-group mb-4">
      <kendo-label text="Ticket Source" [optional]="false"></kendo-label>
      <kendo-dropdownlist
        [data]="availableSources()"
        [value]="selectedSource()"
        (valueChange)="onSourceChange($event)"
        [valuePrimitive]="true"
        placeholder="Select a ticket source..."
        class="w-100"
      ></kendo-dropdownlist>
      <small class="text-muted d-block mt-1">
        Select the security tool source to configure specific Type/Sub-Type/Item
      </small>
    </div>

    <!-- Type/Sub-Type/Item Configuration -->
    <div class="form-group">
      <kendo-label text="Service Type Configuration" class="mb-2 d-block"></kendo-label>
      <app-type-subtype-item-row
        [organizationId]="organizationId()"
        [boardId]="boardId()"
        [config]="currentConfig()"
        [disabled]="!selectedSource()"
        (configChanged)="onConfigChanged($event)"
      ></app-type-subtype-item-row>
      <small class="text-muted d-block mt-2">
        All fields are optional. Sub-Type requires Type. Item is based on the selected board.
      </small>
    </div>
  </div>

  <kendo-dialog-actions>
    <button kendoButton (click)="close()">Cancel</button>
    <button
      kendoButton
      themeColor="primary"
      (click)="save()"
      [disabled]="!isSaveEnabled()"
    >
      Save
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
